import React, { SVGProps } from 'react'
const SvgVirtualCardNeedsApproval = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <rect width="20" height="20" rx="10" fill="black" />
    <path
      d="M5.19995 8.45753V8.06706C5.19995 7.14658 5.94614 6.40039 6.86662 6.40039H13.1333C14.0538 6.40039 14.8 7.14658 14.8 8.06706V8.45753M5.19995 8.45753H14.8M5.19995 8.45753L5.19995 11.9337C5.19995 12.8542 5.94614 13.6004 6.86662 13.6004H13.1333C14.0538 13.6004 14.8 12.8542 14.8 11.9337V8.45753M10.5159 11.4827H12.88"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgVirtualCardNeedsApproval
